import React from "react";


const Payments = ({ selectedId, payments, enablePayments, onChange, onSubmit }) => {
	var T = window.Texts.checkout;
	return (
		<div className="box form-box payment-methods">
			<h2>{T.payment}</h2>
			<ul>
				{payments.map((payment) => {
					return ((enablePayments.indexOf(payment.id) > -1) ?
						<li key={'payment' +  payment.id}>
							<label className={(payment.id == selectedId) ? 'active' : ''}>
								<input value={payment.id} name="OrderPaymentMethod" type="radio" checked={payment.id == selectedId} onChange={(e)=>onChange(e)}/>
								{payment.name}
								{(window.Config.mode == 'liveua' && payment.paidUponReceipt) ?
								<div className="xo-labelInside tarif">{(payment.priceTable.totalPriceInclVat > 0) ? payment.priceTable.displayTotalPriceInclVat : T.tarif}</div> :
														<div className="xo-labelInside">
										{(payment.priceTable.totalPriceInclVat > 0) ? payment.priceTable.displayTotalPriceInclVat : T.free}</div>}									
								<div style={{ clear: 'both' }} />
							</label>
							{(payment.gateway == "homecred" && payment.id == selectedId) ? <small style={{ fontSize:'small' }}>Berete na vědomí, že Vaše osobní údaje v rozsahu jméno, příjmení, adresa, e-mail, telefon, budou předány společnosti Home Credit a.s., Nové sady 996/25, 602 00 Brno, IČO 26978636, e-mail: <a href="mailto:info@homecredit.cz">info@homecredit.cz</a>, zapsané v obchodním rejstříku vedeném Krajským soudem v Brně, oddíl B, vložka 4401 (dále jen 'HC') za účelem předvyplnění formuláře žádosti o poskytnutí služby.</small> : null}
						</li> : null);
				}
				)}
			</ul>
			<div className="payment-submit">
				<button onClick={(e) => onSubmit(e)} className="btn btn50 iconed icon-continue"><span>{T.continue_}</span></button>
				{T.paymentNote ?
					<div className="payment-note">{T.paymentNote}</div> : null}
			</div>
		</div>

	);
};

export default Payments;